import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { AccountContext } from "context/account";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiTagInput from "components/SuiTagInput";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NumbersIcon from "@mui/icons-material/Numbers";

import toast from "react-hot-toast";

import ImageEditor from "@toast-ui/react-image-editor";

import { nanoid } from "nanoid";

import api from "services/api";
import moment from "moment";

import { dataURLtoFile, getImageDimensions } from "utils/imageHelper";

const ImageEditorModal = React.forwardRef(
  ({ visible, handleClose, selectedItem, handleAfterSave = () => {} }, ref) => {
    const [loading, setLoading] = useState(false);
    const editImgRef = useRef(null);

    const saveEditImg = async () => {
      setLoading(true);
      try {
        const editorInstance = editImgRef.current.getInstance();
        const imageDataFile = dataURLtoFile(editorInstance.toDataURL(), nanoid());
        const uploadedImg = await api.uploads
          .create([imageDataFile])
          .then(({ data }) => {
            const uploaded = data.uploads.map(({ url }) => url);
            return uploaded;
          })
          .catch((err) => {
            console.log(err);
            toast.error("Save image failed!");
          });
        if (uploadedImg.length === 1) {
          var url = uploadedImg[0];
          const { width, height } = await getImageDimensions(url);
          handleAfterSave(selectedItem, { url: url, width: width, height: height });
          setLoading(false);

          handleClose();
        }
      } catch (err) {
        toast.error("Failed to save image!");
        console.log(err);
        setLoading(false);
      }
    };

    return (
      <Dialog
        open={visible}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={(e, reason) => {
          handleClose();
        }}
        maxWidth="lg"
        // sx={{
        //   "& .MuiDialog-container": {
        //     "& .MuiPaper-root": {
        //       maxWidth: "950px",
        //       width: "950px",
        //       height: "730px",
        //       maxHeight: "730px",
        //     },
        //   },
        // }}
      >
        <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={loading}>
          <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
          <SuiTypography variant="h6" fontWeight="medium" color="info">
            Saving ...
          </SuiTypography>
        </Backdrop>
        <DialogTitle id="alert-dialog-title">
          {"Image Editor"}

          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: "auto", py: 0 }}>
          <SuiBox sx={{ width: 900 }} display="flex" alignItems="center" justifyContent="center">
            <div style={{ position: "relative", overflow: "auto" }}>
              {selectedItem?.img?.url ? (
                <ImageEditor
                  ref={editImgRef}
                  includeUI={{
                    theme: { "header.display": "none" },
                    loadImage: {
                      path: selectedItem?.img?.url,
                      name: "image",
                    },
                    uiSize: {
                      width: "900px",
                      height: "500px",
                    },
                    menuBarPosition: "right",
                    menu: [
                      "crop",
                      "rotate",
                      "draw",
                      "eraser",
                      "shape",
                      "icon",
                      "text",
                      "mask",
                      "filter",
                    ],
                    initMenu: "draw",
                  }}
                  cssMaxHeight={500}
                  cssMaxWidth={480}
                  usageStatistics={false}
                  selectionStyle={{
                    cornerSize: 5,
                    rotatingPointOffset: 70,
                  }}
                />
              ) : null}
            </div>
          </SuiBox>
        </DialogContent>
        <DialogActions sx={{ py: "10px" }}>
          <SuiButton onClick={saveEditImg} color={"dark"} variant="gradient">
            Save
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  }
);

export default ImageEditorModal;
